import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faUserPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import { showToast } from '../Modais/Toast';
import { AdicionarUsuarioModal } from '../Modais/Modal';

function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length,c.length);
    }
    return null;
}

const Usuarios = ({ handleBackToCards, showToast }) => {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddUserModal, setShowAddUserModal] = useState(false); // Estado para controlar o modal
    const [editingUser, setEditingUser] = useState(null);

    // Busca os usuários da API
    const fetchUsuarios = async () => {
        setLoading(true);
        try {
            const token = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/buscar`, {
                method: 'POST',
                headers: {
                    'Authority': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });

            const result = await response.json();
            
            if (result.status === "ok") {
                setUsuarios(result.lista);
            } else {
                showToast(result.mensagem || 'Erro ao carregar usuários', 'error');
            }
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
            showToast('Erro ao carregar usuários', 'error');
        } finally {
            setLoading(false);
        }
    };
  
    const handleAddUser = async (usuarioData) => {
        try {
            if (!usuarioData.nome || !usuarioData.email) {
                alert('Preencha todos os campos obrigatórios');
                return;
            }

            const token = getCookie("info");
            const senhaTemporaria = "TempPass@" + Math.random().toString(36).slice(-8);
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/cadastrar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authority': token || '',
                },
                body: JSON.stringify({
                    nome: usuarioData.nome,
                    email: usuarioData.email,
                    cargo: usuarioData.cargo || 'user',
                    senha: senhaTemporaria,
                    confirmar_Senha: senhaTemporaria
                })
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.mensagem || 'Erro ao cadastrar usuário');
            }

            const result = await response.json();
            
            if (result.status === "ok") {
                alert('Usuário cadastrado com sucesso! Um e-mail foi enviado para que ele defina sua senha.');
                fetchUsuarios();
                setShowAddUserModal(false);
            } else {
                throw new Error(result.mensagem || 'Erro ao cadastrar usuário');
            }
        } catch (error) {
            console.error('Erro detalhado:', error);
            alert(error.message || 'Erro ao cadastrar usuário');
        }
    };

    const handleUpdateUser = async (usuarioData) => {
        try {
            if (!usuarioData.nome || !usuarioData.email) {
                alert('Preencha todos os campos obrigatórios');
                return;
            }

            const token = getCookie("info");
            
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/atualizar`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authority': token || '',
                },
                body: JSON.stringify({
                    id: usuarioData.id,
                    nome: usuarioData.nome,
                    email: usuarioData.email,
                    cargo: usuarioData.cargo,
                    status: usuarioData.status
                })
            });

            const result = await response.json();
            
            if (result.status === "ok") {
                showToast('Usuário atualizado com sucesso!', 'success');
                fetchUsuarios();
                setEditingUser(null);
            } else {
                throw new Error(result.mensagem || 'Erro ao atualizar usuário');
            }
        } catch (error) {
            console.error('Erro ao atualizar usuário:', error);
            showToast(error.message || 'Erro ao atualizar usuário', 'error');
        }
    };

    useEffect(() => {
        fetchUsuarios();
    }, []);

    const getStatusClass = (status) => {
        switch(status) {
            case 'ativo': return 'status-ativo';
            case 'bloqueado': return 'status-bloqueado';
            case 'pendente': return 'status-pendente';
            default: return 'status-padrao';
        }
    };

    const getInitials = (name) => {
        if (!name) return '';
        const parts = name.split(' ').filter(Boolean);
        if (parts.length === 0) return '';
        if (parts.length === 1) return parts[0][0].toUpperCase();
        return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    };

    return (
        <section className="usuarios-container">
                <AdicionarUsuarioModal
                    show={showAddUserModal || editingUser !== null }
                    fecharModal={() => {setShowAddUserModal(false);
                                        setEditingUser(null);
                    }}
                    salvarUsuario={editingUser ? handleUpdateUser : handleAddUser}
                    usuario={editingUser}
                    isEditing={editingUser !== null}
                />
                <div className="header-right">
                    <h2>Gerenciar  Usuários</h2>
                    <button className="btn-add-user" onClick={() => setShowAddUserModal(true)}>
                        <FontAwesomeIcon icon={faUserPlus} /> Adicionar Usuário
                    </button>
                </div>

                {loading ? (
                    <div className="loading">Carregando usuários...</div>
                ) : (
                    <div className="usuarios-table">
                        <div className="usuario-table-header">
                            <div className="header-cell">Usuário</div>
                            <div className="header-cell">Último Acesso</div>
                            <div className="header-cell">Cargo</div>
                            <div className="header-cell">Status</div>
                            <div className="header-cell">Ações</div>
                        </div>

                        <div className="table-body">
                            {usuarios.map(usuario => (
                                <div key={usuario.id} className="user-card">
                                    <div className="user-cell">
                                        <div className="user-info">
                                            <div className="user-avatar" >
                                                {getInitials(usuario.nome)}
                                            </div>
                                            <div>
                                                <div className="user-name">{usuario.nome}</div>
                                                <div className="user-email">{usuario.email}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="user-cell">
                                        <div className="access-date">{usuario.ultimo_acesso_data}</div>
                                        <div className="access-time">{usuario.ultimo_acesso_hora}</div>
                                    </div>
                                    
                                    <div className="user-cell">
                                        <div className="user-role">{usuario.cargo}</div>
                                    </div>
                                    
                                    <div className="user-cell">
                                        <div className={`user-status ${getStatusClass(usuario.status)}`}>
                                            {usuario.status}
                                        </div>
                                    </div>
                                    
                                    <div className="user-cell">
                                        <button 
                                            className="btn-edit"
                                            onClick={() => setEditingUser({
                                                id: usuario.id,
                                                nome: usuario.nome,
                                                email: usuario.email,
                                                cargo: usuario.cargo,
                                                status: usuario.status
                                            })}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            
        </section>
    );
};

export default Usuarios;